import { GQL_ID } from '@@types'
import { gql, useMutation } from '@apollo/client'

type Mutation = {
  setReviewInvite: boolean
}

type Variables = {
  order_id: GQL_ID
  reviewInvite: boolean
}

export const GQL_MUTATION_UPDATE_REVIEW_INVITE = gql`
  mutation setReviewInvite($order_id: ID!, $reviewInvite: Boolean!) {
    setReviewInvite(order_id: $order_id, reviewInvite: $reviewInvite)
  }
`

export const useMutateUpdateReviewInvite = () =>
  useMutation<Mutation, Variables>(GQL_MUTATION_UPDATE_REVIEW_INVITE)
